import { StoreMappingCreatePage } from "@/features/store-mapping/pages/StoreMappingCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/store-mapping/create")({
	component: StoreMappingCreatePage,
});
